module.exports = __webpack_public_path__ + "img/LNB_place.6cb284f3.svg";